// @flow

import { locale } from 'core/config';
import calculateJobIndex from './calculateJobIndex';

const addFilterParams = (link: string, index: number ) => {
  const rootEl = document.querySelector('.search-data');

  const query = window.location.search.length ? `${window.location.search}&` : '?';
  const linkLocale = `&locale=${locale}`;
  const jobIndex = `&job_index=${calculateJobIndex(index)}`;
  const pageNameParam = rootEl && rootEl.dataset.page ? `&page_name=${rootEl.dataset.page}` : '';
  const categoryIdParam = rootEl && rootEl.dataset.categoryId ? `&filters[category_ids] = [${+rootEl.dataset.categoryId}]` : '';
  const industryIdParam = rootEl && rootEl.dataset.industryId ? `&filters[industry_ids] = [${+rootEl.dataset.industryId}]` : '';
  const companyIdParam = rootEl && rootEl.dataset.id ? encodeURI(`&filters[company_id]=${+rootEl.dataset.id}`) : '';

  return link + query + linkLocale + jobIndex + pageNameParam + categoryIdParam + industryIdParam + companyIdParam;
};

export default addFilterParams;
